// Filter text for hiding personal information messages
const PERSONAL_INFO_FILTER_TEXT =
  "Below is my personal information. Read it and I will start asking you questions, respond in the language in which the questionnaire is filled out";

// Filter text for hiding files attached fallback messages
const FILES_ATTACHED_FILTER_PREFIX = "📎";

/**
 * Checks if a message should be hidden from the chat interface
 * @param content - The message content to check
 * @returns true if the message should be hidden, false otherwise
 */
function shouldHideMessage(content: string): boolean {
  const trimmedContent = content.trim();

  // Also check the exact filter text for backward compatibility
  if (trimmedContent.startsWith(PERSONAL_INFO_FILTER_TEXT)) {
    return true;
  }

  // Hide personal information messages - check for the beginning pattern
  // This catches variations like with/without (23dsa2) or other suffixes
  if (
    trimmedContent.startsWith(
      "Below is my personal information. Read it and I will start asking you questions"
    )
  ) {
    return true;
  }

  // Hide files attached fallback messages that appear during intro message processing
  if (trimmedContent.startsWith(FILES_ATTACHED_FILTER_PREFIX)) {
    return true;
  }

  return false;
}

export {
  shouldHideMessage,
  PERSONAL_INFO_FILTER_TEXT,
  FILES_ATTACHED_FILTER_PREFIX,
};
